import axios from 'axios';

export const getPrepayFormConfig = (shootKey) => {
  return axios.get('/api/v2/prepay-form-config', {
    params: { shoot_key: shootKey },
  });
};

export default {
  getPrepayFormConfig,
};
